// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as DOMPurify$LiveRoom from "../../bindings/DOMPurify.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../../styles/StyleConstants.bs.js";
import * as Tokens from "@sothebys/sterling/tokens";

var textBlock = Curry._1(Css.style, {
      hd: Css.fontFamily({
            NAME: "custom",
            VAL: Tokens.FontFamily.mercuryDisplay
          }),
      tl: {
        hd: Css.display(Css.block),
        tl: {
          hd: Css.height(Css.vh(60.0)),
          tl: {
            hd: Css.media("(max-width:" + (StyleConstants$LiveRoom.mobileBreakpoint + ")"), {
                  hd: Css.height(Css.vh(90.0)),
                  tl: /* [] */0
                }),
            tl: {
              hd: Css.paddingLeft(Css.pct(8.0)),
              tl: {
                hd: Css.paddingRight(Css.pct(8.0)),
                tl: {
                  hd: Css.overflow(Css.scroll),
                  tl: {
                    hd: Css.overflowX("hidden"),
                    tl: {
                      hd: Css.paddingBottom(Css.px(40)),
                      tl: {
                        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey90_nohashtag)),
                        tl: {
                          hd: Css.lineHeight({
                                NAME: "em",
                                VAL: 2.0
                              }),
                          tl: {
                            hd: Css.selector(" a", {
                                  hd: Css.fontWeight({
                                        NAME: "num",
                                        VAL: 600
                                      }),
                                  tl: {
                                    hd: Css.textDecoration("none"),
                                    tl: {
                                      hd: Css.visited({
                                            hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey90_nohashtag)),
                                            tl: /* [] */0
                                          }),
                                      tl: {
                                        hd: Css.hover({
                                              hd: Css.borderBottom(Css.px(2), Css.solid, Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey90_nohashtag)),
                                              tl: /* [] */0
                                            }),
                                        tl: {
                                          hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey90_nohashtag)),
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                }),
                            tl: {
                              hd: Css.selector(" strong", {
                                    hd: Css.fontWeight({
                                          NAME: "num",
                                          VAL: 600
                                        }),
                                    tl: /* [] */0
                                  }),
                              tl: {
                                hd: Css.selector(" em", {
                                      hd: Css.fontStyle(Css.italic),
                                      tl: /* [] */0
                                    }),
                                tl: {
                                  hd: Css.selector(" u", {
                                        hd: Css.textDecoration(Css.underline),
                                        tl: /* [] */0
                                      }),
                                  tl: {
                                    hd: Css.media("(max-width:" + (StyleConstants$LiveRoom.mobileBreakpoint + ")"), {
                                          hd: Css.paddingLeft(Css.px(20)),
                                          tl: {
                                            hd: Css.paddingRight(Css.px(20)),
                                            tl: {
                                              hd: Css.paddingBottom(Css.px(20)),
                                              tl: {
                                                hd: Css.height(Css.vh(100.0)),
                                                tl: /* [] */0
                                              }
                                            }
                                          }
                                        }),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

function ConditionOfSale(props) {
  return React.createElement("div", {
              className: textBlock,
              dangerouslySetInnerHTML: {
                __html: DOMPurify$LiveRoom.sanitize(props.conditionOfSaleText)
              }
            });
}

var make = ConditionOfSale;

export {
  textBlock ,
  make ,
}
/* textBlock Not a pure module */
